module.exports = __webpack_public_path__ + "static/media/criptomonedas.2f7b58e5.jpg";